import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

// TODO: currently triggered from all/libraries/analytics/ELC.ProductSkuDataLayer.js in drupal
// whole thing needs to be ported and inegrated with shade selector

const defaultData: IDataLayer = {
  event_name: 'product_detail_shade_size',
  enh_action: 'detail',
  event_category: 'ecommerce',
  event_action: 'spp',
  event_label: 'shade size switch'
};

function trackSkuChange(_: string, eventData: IDataLayer = {}) {
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('skuChange', trackSkuChange);
